<template>
  <b-form @submit.prevent="onSubmit">
    <b-row>
      <b-col lg="6" md="6">
        <form-group :validations="$v.form.name">
          <div slot-scope="{ errors, invalid }">
            <b-form-group
                id="input-group-1"
                label="نام"
                label-for="input-1"
                description=""
            >
              <b-form-input
                  id="input-1"
                  v-model="form.name"
                  placeholder="نام"
                  :class="{ invalid }"
              ></b-form-input>
              <form-errors-manager :errors="errors"/>
            </b-form-group>
          </div>
        </form-group>
      </b-col>

      <b-col lg="6" md="6">
        <form-group :validations="$v.form.last_name">
          <div slot-scope="{ errors, invalid }">
            <b-form-group
                id="input-group-6"
                label="نام خانوادگی"
                label-for="input-6"
                description=""
            >
              <b-form-input
                  id="input-6"
                  v-model="form.last_name"
                  type="text"
                  placeholder="نام خانوادگی"
                  :class="{ invalid }"
              ></b-form-input>
              <form-errors-manager :errors="errors"/>
            </b-form-group>
          </div>
        </form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col lg="4" md="4">
        <form-group :validations="$v.form.email">
          <div slot-scope="{ errors, invalid }">
            <b-form-group id="input-group-2" label="ایمیل" label-for="input-2">
              <b-form-input
                  class="text-left"
                  id="input-2"
                  v-model="form.email"
                  type="text"
                  placeholder="ایمیل خود را وارد کنید"
                  :class="{ invalid }"
              ></b-form-input>
              <form-errors-manager :errors="errors"/>

              <a
                  href="#"
                  v-if="
                   (form.email_verified_at == null && $route.params.id !== undefined) || (form.email_verified_at == null && $route.name == 'Profile')"
                  @click.prevent="sendEmailVerificationCode(form)"
              >
                تایید ایمیل
              </a>
            </b-form-group>
          </div>
        </form-group>
      </b-col>

      <b-col lg="4" md="4">
        <form-group :validations="$v.form.cellphone">
          <div slot-scope="{ errors, invalid }">
            <b-form-group
                id="input-group-4"
                label="تلفن همراه"
                label-for="input-4"
            >
              <b-form-input
                  id="input-4"
                  class="text-left"
                  v-model="form.cellphone"
                  :class="{ invalid }"
              ></b-form-input>
              <form-errors-manager :errors="errors"/>
              <a
                  href="#"
                  v-if="(form.cellphone_verified_at == null && $route.params.id !== undefined) || (form.cellphone_verified_at == null && $route.name == 'Profile')"
                  @click.prevent="sendCellPhoneVerificationCode(form)">
                تایید شماره تلفن همراه</a>
            </b-form-group>
          </div>
        </form-group>
      </b-col>

      <b-col lg="4" md="4">
        <form-group :validations="$v.form.role" v-if="changeRole">
          <div slot-scope="{ errors, invalid }">
            <b-form-group id="role" label="نقش" label-for="role">
              <b-form-select
                  :disabled="form.id == $store.getters['User/getProfile'].id &&   $store.getters['User/getProfile'].role == 1"
                  v-model="form.role"
                  :options="roles"
              ></b-form-select>
              <form-errors-manager :errors="errors"/>
            </b-form-group>
          </div>
        </form-group>
      </b-col>
    </b-row>


    <b-row v-if="$route.params.id == undefined && $route.name == 'CreateUser' ">
      <b-col lg="4" md="4" v-if="!changeRole">
        <form-group :validations="$v.form.current_password">
          <div slot-scope="{ errors, invalid }">
            <b-form-group
                id="input-group-7"
                label="رمز عبور کنونی"
                label-for="input-7"
            >
              <b-form-input
                  autocomplete="off"
                  id="input-7"
                  type="password"
                  v-model="form.current_password"
                  placeholder="رمز عبور کنونی"
                  :class="{ invalid }"
              >
              </b-form-input>

              <form-errors-manager :errors="errors"/>
            </b-form-group>
          </div>
        </form-group>
      </b-col>

      <b-col lg="4" md="4">
        <form-group :validations="$v.form.password">
          <div slot-scope="{ errors, invalid }">
            <b-form-group
                id="input-group-5"
                label="رمز عبور جدید"
                label-for="input-5"
            >
              <b-form-input
                  autocomplete="off"
                  id="input-5"
                  placeholder="رمز عبور جدید"
                  type="password"
                  v-model="form.password"
                  :class="{ invalid }"
              >
              </b-form-input>
              <form-errors-manager :errors="errors"/>
            </b-form-group>
          </div>
        </form-group>
      </b-col>

      <b-col lg="4" md="4">
        <form-group :validations="$v.form.password_confirmation">
          <div slot-scope="{ errors, invalid }">
            <b-form-group
                id="input-group-9"
                label="تکرار رمز عبور جدید"
                label-for="input-9"
            >
              <b-form-input
                  id="input-9"
                  autocomplete="off"
                  type="password"
                  placeholder="تکرار رمز عبور جدید"
                  v-model="form.password_confirmation"
                  :class="{ invalid }"
              ></b-form-input>
              <form-errors-manager :errors="errors"/>
            </b-form-group>
          </div>
        </form-group>
      </b-col>
    </b-row>


    <router-link class="text-decoration-none" v-if="$route.params.id !== undefined || $route.name =='Profile'"
                 :to="{ name: 'UpdateUserPassword', params: { id: form.id } }">

      <span class="btn btn-secondary rounded-pill mt-3">تغییر رمز عبور</span>

    </router-link>


    <b-row>
      <b-button type="submit" pill variant="purple" class="w-100 mt-4"
      >تایید
      </b-button
      >
    </b-row>
  </b-form>
</template>


<script>
import {mapGetters, mapActions} from "vuex";
import FormGroup from "../../components/validator/FormGroup";
import FormErrorsManager from "../../components/validator/FormErrorsManager.vue";
import {
  sameAs,
  required,
  requiredIf,
  minLength,
  email,
} from "vuelidate/lib/validators";
import {phone} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/VuelidateCustomValidatoins";
import {dateConverter} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";

export default {
  name: "ProfileComponent",
  props: ["form", "submit", "changeRole"],
  components: {FormGroup, FormErrorsManager},
  data() {
    return {
      roles: [
        {text: "کاربر عادی", value: 0},
        {text: "مدیر سایت", value: 1},
      ],
    };
  },
  validations() {
    if (this.$route.name == 'CreateUser') {

      return {

        form: {
          name: {required},
          last_name: {required},
          cellphone: {required, phone},
          email: {
            required: requiredIf(function () {
              return this.form.email != null && this.form.email != "";
            }),
            email,
          },
          role: {
            required: true,
          },
          password: {
            required
          },
          password_confirmation: {
            required
          },
        }
      }
    }

    return {
      form: {
        name: {required},
        last_name: {required},
        cellphone: {required, phone},
        role: {required},
        email: {
          required: requiredIf(function () {
            return this.form.email != null && this.form.email != "";
          }),
          email,
        },
      }
    }

  },
  computed: {
    ...mapGetters({
      isPhoneVerified: "User/isPhoneVerified",
      isEmailVerified: "User/isEmailVerified",
    }),
  },
  methods: {
    dateConverter,
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    ...mapActions({
      sendCellPhoneVerificationCode:
          "Authentication/sendCellPhoneVerificationCode",
      sendEmailVerificationCode: "Authentication/sendEmailVerificationCode",
    }),
    onSubmit() {
      if (this.invalid()) {
        this.submit(this.form);
      }
    },
  },
  mounted() {

  }
};
</script>

<style scoped>
</style>